export const checkStatus = (status) => (
    status && status.type === 'affiliate' && status.affiID
)